<template>
  <div class="entry-page">
    <NavBar />
    <div class="about-page">
      <section v-if="carousel[0]" class="carouselStyle">
        <img
          class="computer"
          style="opacity: 0"
          :src="carousel[0].BannerPic"
          alt=""
        />
        <img
          class="mobile"
          style="opacity: 0"
          :src="carousel[0].BannerPicMobile"
          alt=""
        />
        <el-carousel :interval="5000" arrow="always" indicator-position="none">
          <el-carousel-item v-for="item in carousel" :key="item.Guid">
            <img class="computer" :src="item.BannerPic" alt="" />
            <img class="mobile" :src="item.BannerPicMobile" alt="" />
          </el-carousel-item>
        </el-carousel>
      </section>
      <a
        href="#about-list"
        style="
          position: absolute;
          bottom: 10%;
          left: 50%;
          transform: translate(-50%, 0);
          z-index: 10000;
        "
      >
        <eva-icon
          name="arrowhead-down-outline"
          fill="#F7F9F9"
          width="30"
          height="30"
        />
      </a>

      <template>
        <div id="about-list" v-for="item in block" :key="item.Guid">
          <section v-if="item.Position === '無'" class="block-text">
            <div class="text-wrap">
              <div class="title">{{ item.Title }}</div>
              <div class="desc">
                <pre>{{ item.Content }}</pre>
              </div>
            </div>
          </section>

          <section v-if="item.Position === '左'" class="block-img-left">
            <div class="text-wrap">
              <div class="title">{{ item.Title }}</div>
              <div class="desc">
                <pre>{{ item.Content }}</pre>
              </div>
            </div>
            <div class="img-wrap">
              <img :src="item.Pic" alt="" />
            </div>
          </section>

          <section v-if="item.Position === '右'" class="block-img-right">
            <div class="text-wrap">
              <div class="title">{{ item.Title }}</div>
              <div class="desc">
                <pre>{{ item.Content }}</pre>
              </div>
            </div>
            <div class="img-wrap">
              <img :src="item.Pic" alt="" />
            </div>
          </section>
        </div>
        <div style="position: relative">
          <a
            href="#job-lists"
            style="
              position: absolute;
              bottom: 10%;
              left: 50%;
              transform: translate(-50%, 0);
              z-index: 999;
            "
          >
            <eva-icon
              name="arrowhead-down-outline"
              fill="#000"
              width="25"
              height="25"
            />
          </a>
        </div>
      </template>

      <section
        id="job-lists"
        class="job-section"
        :style="{ backgroundImage: 'url(' + background + ')' }"
      >
        <div class="title">
          <span>{{ i18n("Homepage.JobOpenings") }}</span>
        </div>
        <div class="job-list">
          <div class="row" style="margin-bottom: 5px">
            <div class="col-md-3">
              <input
                style="margin-bottom: 5px"
                type="text"
                class="form-control"
                :placeholder="i18n('Homepage.Keyword')"
                v-model.trim="searchCondition.ManpowerDemandName"
                @keydown.stop.prevent.enter="getJobOpening"
              />
            </div>
            <div class="col-md-3">
              <el-select
                class="w-100"
                :filterable="true"
                clearable
                placeholder="地點不拘"
                v-model="searchCondition.WorkPlace"
              >
                <el-option
                  v-for="workplace in workplaceOptions"
                  :key="workplace.Guid"
                  :label="workplace.WorkPlaceName"
                  :value="workplace.WorkPlaceName"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-md-2">
              <button
                class="btn btn-sm w-100"
                @click="getJobOpening"
                style="
                  margin-bottom: 5px;
                  height: 37px;
                  background: #f54c4a;
                  color: #fff;
                "
              >
                <eva-icon name="search-outline" fill="#fff"></eva-icon>
                {{ i18n("Homepage.Search") }}
              </button>
            </div>
          </div>

          <div v-for="item in jobOpeningList" :key="item.No" class="job">
            <div class="info">
              <div class="name" @click="jobModal(item)">
                {{ item.ManpowerDemandName }}
                <eva-icon name="question-mark-circle" fill="red"></eva-icon>
                <div class="tag">
                  <span v-for="place in item.WorkPlace" :key="place">
                    {{ place }}
                  </span>
                </div>
              </div>
              <br/>
              <div class="tag">
                <span v-if="item.WorkExperienceWhatever">
                  工作經驗不拘 Regardless of work experience
                </span>
                <span v-else>{{ item.WorkExperience }} 年以上</span>
                <span v-if="item.EducationDemandWhatever">
                  學歷不拘 Regardless of education
                </span>
                <span
                  v-else
                  v-for="(education, index) in item.EducationDemand"
                  :key="index"
                >
                  {{ education }}
                </span>
              </div>
              <div class="desc">
                <pre style="font-size: 14px">{{ item.WorkContent }}</pre>
              </div>
            </div>
            <div class="edit">
              <button type="btn" class="btn" @click="apply(item.No)">
                {{ i18n("Homepage.Recruit") }}
              </button>
            </div>
          </div>
        </div>
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="10"
          :total="totalData"
          @current-change="changePage"
          style="text-align: center"
        >
        </el-pagination>
      </section>

      <div
        class="modal fade"
        id="jobModal"
        tabindex="-1"
        aria-labelledby="jobModal"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <span class="modal-title">
                {{ job.ManpowerDemandName }}-職務說明
              </span>
            </div>
            <div class="modal-body">
              <span v-if="job.PositionInstruction === null">尚無說明</span>
              <pre v-else>{{ job.PositionInstruction }}</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="top-icon">
      <eva-icon name="arrowhead-up-outline" fill="#ffffff" @click="scrollTop" />
    </div>
    <Footer :page="'HomePage'" />
  </div>
</template>

<script>
/* global $ */
import moment from "moment";

import NavBar from "@/components/HomePage/NavBar";
import Footer from "@/components/Layout/Footer";

window.history.forward(1);

export default {
  name: "HomePage",

  components: {
    NavBar,
    Footer,
  },
  data() {
    return {
      // 輪博
      carousel: [],
      // 區塊
      block: [],
      // 背景圖
      background: {},

      // 工作地點選項
      workplaceOptions: [],

      // 職務說明
      job: {},

      // 查詢條件
      searchCondition: {},
      totalData: 0, // 總筆數
      currentPage: 1, // 當前頁數

      // 職缺列表
      jobOpeningList: [],

      year: null, // 年
      date: null, // 日期
    };
  },

  methods: {
    // 我要應徵
    apply() {
      if (this.$cookies.get("candidateId")) {
        this.$common.checkConsentForm();
      } else {
        this.$router.push({ path: "signIn" });
      }
    },

    // 取得 職缺列表
    getJobOpening() {
      this.$api.jobOpening
        .getJobOpeningPaging({
          ...this.searchCondition,
          Page: this.currentPage,
          PerPage: 10,
        })
        .then((response) => {
          if (response.status === 200) {
            this.jobOpeningList = response.data.Datas;
            this.totalData = response.data.Quantity;
          }
        });
    },

    // 取得 輪播
    getCarousel() {
      const vm = this;
      const api = `${window.endpoints.api}/FrontPageBanner`;

      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200 && response.data.length > 0) {
            vm.carousel = response.data;
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "輪播圖取得失敗",
            message: error.response.data,
            type: "error",
            duration: 0,
          });
        });
    },

    // 取得 區塊
    getBlock() {
      const vm = this;
      const api = `${window.endpoints.api}/CompanyProfile`;

      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200 && response.data.length > 0) {
            vm.block = response.data;
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "區塊取得失敗",
            message: error.response.data,
            type: "error",
            duration: 0,
          });
        });
    },

    // 取得 職缺列表背景圖
    getBackground() {
      const vm = this;
      const api = `${window.endpoints.api}/BasicInformation/IndexBackgroundImg`;

      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200 && response.data.length > 0) {
            vm.background = response.data;
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "背景取得失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 職務說明
    jobModal(item) {
      $("#jobModal").modal("show");
      this.job = { ...item };
    },

    // 換頁
    changePage(val) {
      this.currentPage = val;
      this.getJobOpening();
    },

    // 回到頂部
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },

    async getData() {
      await this.getCarousel();
      await this.getBlock();
      await this.getBackground();
      await this.getJobOpening();
      // 取得 工作地點選項
      const workplace = await this.$api.workplace.getWorkplace();
      this.workplaceOptions = workplace.data;
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  filters: {
    year: function (date) {
      return moment(date).format("YYYY");
    },
    date: function (date) {
      return moment(date).format("MM/DD");
    },
  },

  created() {
    localStorage.removeItem("PLACE");
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.computer {
  display: block;
}
.mobile {
  display: none;
}

@media only screen and (max-width: 768px) {
  .computer {
    display: none;
  }
  .mobile {
    display: block;
  }
}

.top-icon {
  position: fixed;
  margin: 0 auto;
  bottom: 35px;
  right: 20px;
  cursor: pointer;
  @media only screen and (max-width: 767px) {
    bottom: 25px;
    right: 0px;
  }
}

.about-page {
  pre {
    font-size: 16px;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  font-family: "Quicksand", sans-serif;
  .carouselStyle {
    position: relative;

    /deep/.el-carousel {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
    }
    /deep/ .el-carousel__container {
      height: 100% !important;
    }
    .text-wrap {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.3);
      z-index: 4;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);

      color: #fff;

      h1 {
        font-weight: bold;
        font-size: 3em;
      }
      h5 {
        letter-spacing: 3px;
        font-weight: bold;
      }
    }
    img {
      width: 100%;
    }
  }

  .block-text {
    width: 100%;
    max-width: 960px;
    display: flex;
    margin: 40px auto;

    .text-wrap {
      .title {
        font-weight: bold;
        font-size: 2em;
        border-bottom: 5px solid #f54c4a;
        display: inline-block;
        margin-bottom: 10px;
      }
      width: 100%;
      background-color: #fff;
      padding: 40px;
      @media only screen and (max-width: 767px) {
        width: 100%;
      }
      .desc {
        line-height: 200%;
      }
    }
  }

  .block-img-right,
  .block-img-left {
    width: 100%;
    max-width: 960px;
    display: flex;
    margin: 40px auto;

    @media only screen and (max-width: 767px) {
      display: block;
    }

    &.block-img-left {
      flex-direction: row-reverse;
    }

    .text-wrap {
      .title {
        font-weight: bold;
        font-size: 2em;
        border-bottom: 5px solid #f54c4a;
        display: inline-block;
        margin-bottom: 10px;
      }
      width: 50%;
      background-color: #fff;
      padding: 40px;
      @media only screen and (max-width: 767px) {
        width: 100%;
      }
      .desc {
        line-height: 200%;
      }
      pre {
        font-size: 16px;
        white-space: pre-wrap;
        word-wrap: break-word;
      }
    }
    .img-wrap {
      flex: 1;
      min-width: 1px;
      img {
        max-width: 100%;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .job-section {
    background-size: cover;
    padding-top: 100px;
    padding-bottom: 60px;
    background-attachment: fixed;
    background-position: center center;
    cursor: default;

    .title {
      text-align: center;
      span {
        font-weight: bold;
        font-size: 2em;
        border-bottom: 5px solid #f54c4a;
        display: inline-block;
        color: #fff;
        margin-bottom: 40px;
        text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
      }
    }
    .job-list {
      max-width: 960px;
      margin: 0 auto;
      @media only screen and (max-width: 767px) {
        padding: 0 20px;
      }

      .job {
        display: flex;
        border-radius: 5px;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
        background-color: rgba(#fff, 0.9);
        margin-bottom: 10px;
        padding: 15px 5px;
        color: #383838;
        text-decoration: none;
        align-items: center;
        @media only screen and (max-width: 767px) {
          display: block;
          padding: 20px;
          br {
            display: none;
          }
        }
        .date {
          font-weight: bold;
          padding: 15px;
          text-align: center;
          margin-right: 20px;
          color: #383838;
          border-right: 1px solid #bdbdbd;

          @media only screen and (max-width: 767px) {
            border-right: none;
            br {
              display: none;
            }
          }
          .year {
            font-size: 1.3em;
          }
        }
        .info {
          width: 880px;
          @media only screen and (max-width: 767px) {
            max-width: 300px;
          }
          .name {
            font-weight: bold;
            display: inline-block;
            margin-left: 8px;
            @media only screen and (max-width: 767px) {
              display: block;
              text-align: center;
              margin-bottom: 20px;
            }
          }
          .tag {
            display: inline-block;
            span {
              background-color: #f1f1f1;
              padding: 3px 10px;
              border-radius: 25px;
              margin-right: 2px;
              font-size: 0.9em;
            }
          }
          .money {
            display: inline-block;
            background-color: #f1f1f1;
            color: #f54c4a;
            padding: 3px 10px;
            border-radius: 25px;
          }
          .desc {
            margin-top: 10px;
            margin-left: 10px;
            font-size: 0.9em;
            line-height: 175%;
            letter-spacing: 1px;
          }
        }

        .edit {
          margin-left: 10px;
          margin-right: 10px;
          button {
            background-color: #f54c4a;
            color: #ffffff;
            display: inline-block;
            padding: 7px;
            cursor: pointer;
            text-align: center;
            border: none;
            font-weight: bold;
            border-radius: 12px;
            width: 60px;
            height: 60px;
            text-decoration: none;
            box-shadow: 0 6px #f58684;

            word-wrap: break-word;

            &:hover {
              background-color: darken(#f54c4a, 10%);
            }
            &:active {
              background-color: #f54c4a;
              box-shadow: 0 3px #f53836;
              transform: translateY(4px);
            }
            @media only screen and (max-width: 767px) {
              width: 100%;
              height: auto;
            }
          }
        }
      }
    }
  }
}
</style>
